/**
 * @push.rocks/webrequest v4
 * Modern, fetch-compatible web request library with intelligent caching
 */

// Main exports
export { webrequest } from './webrequest.function.js';
export { WebrequestClient } from './webrequest.client.js';

// Type exports
export type {
  IWebrequestOptions,
  ICacheOptions,
  IRetryOptions,
  IInterceptors,
  TCacheStrategy,
  TStandardCacheMode,
  TBackoffStrategy,
  TWebrequestResult,
  IWebrequestSuccess,
  IWebrequestError,
  IWebrequestJsonResult,
  IWebrequestResponseMetadata,
  IWebrequestResponseResult,
  ICacheEntry,
  ICacheMetadata,
} from './webrequest.types.js';

export type {
  TRequestInterceptor,
  TResponseInterceptor,
  TErrorInterceptor,
} from './interceptors/interceptor.types.js';

// Advanced exports for custom implementations
export { CacheManager } from './cache/cache.manager.js';
export {
  CacheStore,
  defaultCacheMaxEntries,
} from './cache/cache.store.js';
export type {
  ICacheStoreOperationOptions,
  ICacheStoreWriteOptions,
} from './cache/cache.store.js';
export { RetryManager } from './retry/retry.manager.js';
export { InterceptorManager } from './interceptors/interceptor.manager.js';
export { RequestDeduplicator } from './utils/deduplicator.js';
export { isWebrequestTimeoutError } from './utils/timeout.js';

// Cache utilities
export {
  extractCacheMetadata,
  isFresh,
  requiresRevalidation,
  createConditionalHeaders,
  headersToObject,
  objectToHeaders,
} from './cache/cache.headers.js';
